import { Box, styled, Typography } from '@mui/material';

export const AssemblyContainer = styled(Box)(
  ({ theme, $isSelected }) =>
    `
  width: min-content;
  display: flex;
  align-items: center;
  height: -webkit-fill-available;
  flex-direction: column;
  border: 2px solid ${theme.palette.secondary.dark};
  padding: 20px;
  gap: 10px;

  &:hover {
    cursor: pointer;
  }

  ${
    $isSelected
      ? `
    box-shadow: 0 4px 4px 0px #00000040;
    border-color: ${theme.palette.primary.main};
    `
      : ''
  }
`,
);

export const NameContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

export const Text = styled(Typography)`
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
`;

export const ChipContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
